import {Injectable} from '@angular/core';
import {CreditAssessmentInfoResolver} from '../borrow/eligibility-check/credit-assessment-info.resolver';
import {Income} from '../model/eligibility-check/income.model';
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';

@Injectable()
export class IncomeResolver implements Resolve<Income> {
    constructor(private creditAssessmentResolver: CreditAssessmentInfoResolver) {
    }

    async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<Income> {
        const creditAssessment = await this.creditAssessmentResolver.resolve(route, state);
        if (creditAssessment) {
            return creditAssessment.income;
        }

        const locallySavedEligibilityCheck = this.creditAssessmentResolver.getLocallySavedEligibilityCheck();
        return locallySavedEligibilityCheck ? Income.from(locallySavedEligibilityCheck.income) : undefined;
    }
}
